import React from 'react';
import { IconButton, Box } from '@mui/material';
import { motion } from 'framer-motion';
import FavoriteIcon from '@mui/icons-material/Favorite';

interface LikeButtonProps {
  onClick: () => void;
  isAnimating: boolean;
  shootingTexts: Array<{ id: number; text: string; angle: number }>;
  size?: 'small' | 'medium' | 'large';
  showFeedback?: boolean;
}

const LikeButton: React.FC<LikeButtonProps> = ({
  onClick,
  isAnimating,
  shootingTexts,
  size = 'medium',
  showFeedback = true
}) => {
  const getIconSize = () => {
    switch (size) {
      case 'small': return 16;
      case 'large': return 24;
      default: return 20;
    }
  };

  const getButtonSize = () => {
    switch (size) {
      case 'small': return 32;
      case 'large': return 48;
      default: return 40;
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <motion.div
        animate={{
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <IconButton
          onClick={onClick}
          sx={{
            transform: isAnimating ? 'scale(1.2)' : 'scale(1)',
            transition: 'all 0.3s ease-in-out',
            background: 'linear-gradient(135deg, rgba(255, 64, 129, 0.1) 0%, rgba(0, 229, 255, 0.1) 100%)',
            width: getButtonSize(),
            height: getButtonSize(),
            '&:hover': {
              background: 'linear-gradient(135deg, rgba(255, 64, 129, 0.2) 0%, rgba(0, 229, 255, 0.2) 100%)',
              transform: 'scale(1.1)',
            },
          }}
        >
          <FavoriteIcon
            sx={{
              fontSize: getIconSize(),
              color: 'primary.main',
            }}
          />
        </IconButton>
             </motion.div>
     </Box>
   );
 };

export default LikeButton;
